import Component from '../core/Component';

export default class LayerOpener extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            origin: null
        }

        this.options = {
            hover: !!this.element.dataset.hover,
            href: this.element.dataset.href
        }
    }

    prepare() {
        if (this.options.hover) {
            this.element.addEventListener('mouseenter', ::this.handleMouseEnter)
            this.element.addEventListener('mouseleave', ::this.handleMouseLeave)
        } else {
            this.element.addEventListener('click', ::this.handleClick);
        }

    }

    handleClick(event) {
        event.preventDefault();
        this.openLayer()
    }

    handleMouseEnter() {
        this.openLayer()
    }

    handleMouseLeave() {
        this.closeLayer()
    }

    getLayerComponent() {
        const target = document.getElementById((this.options.href || this.element.getAttribute('href')).replace('#', ''))

        if (!target) {
            return null
        }

        return Component.getFromElement(target)
    }

    openLayer() {
        const layer = this.getLayerComponent()

        if (layer) {
            layer.open(this.ref.origin || this.element)
        }
    }

    closeLayer() {
        const layer = this.getLayerComponent()

        if (layer) {
            layer.close()
        }
    }
}